/**
 * THIS IS VERY IMPORTANT - DO NOT ADD ANYTHING OR DELETE THIS FILE.
 * IF YOU MUST ADD SOMETHING TO THIS PLEASE ADD IT IN - scripts/templates
 */

export const currentEnv = "prod";
export const baseUrl = "https://konfhub.com";
export const websiteUrl = "https://events.konfhub.com";
export const loginUrl = "https://accounts.konfhub.com";
export const baseUrlQuizhub = "https://quizadmin.konfhub.com";
export const geoLocationAPIKey = "AIzaSyCdKozbbL0QQVyG8PLXmBJ_k6-dpdwkBB0";
export const konfhubTaxID = "29AAVFK1083A1Z8";
export const certhubUrl = "https://cert.konfhub.com";
export const checkinAppUrl = "checkin.konfhub.com";
export const sponsorAppUrl = "sponsor.konfhub.com";
export const copperXUrl = "https://dashboard.copperx.dev/";
export const mediaUrl = "https://media.konfhub.com";
export const regButtonsUrl = "https://widget.konfhub.com/widget.js";
export const quizHubUrl = "https://quiz.konfhub.com";
export const quizHubAdminUrl = "https://quizadmin.konfhub.com";
export const quizhubAppUrl = "https://join.quizhub.app";
export const stripeClientID = "ca_NLgA6ETGYH5DeYg0AFI7JCWDikQwCO0x";
export const galleryUrl = "https://gallery.konfhub.com";
export const photoBoothUrl = "https://aibooth.konfhub.com";
export const pollerApiUrl = "https://regional-api.konfhub.com";
export const recaptchaId = "6LeCYS8iAAAAADUPDMJWwu9sMZIVzC4ElmdUr81r";
export const RECAPTCHA_SCORE = 0.5;
export const recaptchaV2Id = "6LfvQDkrAAAAAECvf6uWWcu9IJ8lUQBP0omP3P8O";
export const oauthDomain = "auth.konfhub.com";
export const webClientId = "5jf10rk2c0muftotp1iu2ucup0";
export const facebookAppId = "713402861504755";
export const facebookConfigId = "1146022400994905";

export const STRIPE_PG = 6;
export const TAP_PG = 7;
export const INDIAN_CURRENCY = "INR";

const currentDate = new Date();
const maintenanceStartDate = new Date("2024-11-03T00:30:00.000+05:30");
const maintenanceEndDate = new Date("2024-11-03T02:00:00.000+05:30");

export const isMaintenanceTime =
    currentDate > maintenanceStartDate && currentDate < maintenanceEndDate;

/**
* THIS IS VERY IMPORTANT - DO NOT ADD ANYTHING OR DELETE THIS FILE.
* IF YOU MUST ADD SOMETHING TO THIS PLEASE ADD IT IN - scripts/templates
*/
